import React, { useState } from "react";
import { API_ENDPOINTS } from "../config/api";
import { authenticatedFetch } from "../config/authenticatedFetch";
import "./VideoUpload.css";

const VideoUpload: React.FC = () => {
  const [speciality, setSpeciality] = useState("");
  const [video, setVideo] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setVideo(e.target.files[0]);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSuccess(null);
    setError(null);
    if (!speciality || !video) {
      setError("Preencha a especialidade e selecione um vídeo mp4.");
      return;
    }
    if (!video.name.toLowerCase().endsWith(".mp4")) {
      setError("Apenas arquivos mp4 são permitidos.");
      return;
    }
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("speciality", speciality);
      formData.append("video", video);
      const response = await authenticatedFetch(API_ENDPOINTS.API_VIDEO, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      if (response.ok && data.success) {
        setSuccess("Vídeo enviado com sucesso!");
        setSpeciality("");
        setVideo(null);
      } else {
        setError(data.error || "Erro ao enviar vídeo.");
      }
    } catch (err) {
      setError("Erro de conexão com o servidor.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="video-upload-container">
      <h2>Enviar Vídeo</h2>
      <form className="video-upload-form" onSubmit={handleSubmit}>
        <label>
          Especialidade:
          <input
            type="text"
            value={speciality}
            onChange={e => setSpeciality(e.target.value)}
            required
            disabled={loading}
          />
        </label>
        <label>
          Vídeo (apenas mp4):
          <input
            type="file"
            accept="video/mp4"
            onChange={handleFileChange}
            required
            disabled={loading}
          />
        </label>
        <button type="submit" disabled={loading}>
          {loading ? "Enviando..." : "Enviar"}
        </button>
      </form>
      {success && <div className="success-message">{success}</div>}
      {error && <div className="error-message">{error}</div>}
    </div>
  );
};

export default VideoUpload;
